import { useMutation } from "@apollo/client";
import { DELETE_MATCH, GET_MATCHES_BY_SEASON_ID } from "../../GraphQL/Matches";
import useNotification from "../../hooks/useNotification.js";
import ConfirmDeleteDialog from "../UI/ConfirmDeleteDialog.js";

const DeleteMatchDialog = (props) => {
  const { notifySuccess } = useNotification();

  const [deleteMatch, { loading, error }] = useMutation(DELETE_MATCH, {
    variables: { id: props.match.id },
    refetchQueries: [GET_MATCHES_BY_SEASON_ID],
    onCompleted: () => {
      notifySuccess("Match deleted.");
      props.setOpen(false);
    },
  });

  return (
    <ConfirmDeleteDialog
      open={props.open}
      setOpen={props.setOpen}
      entityName={`${props.match.homeTeam.name} vs ${props.match.awayTeam.name}`}
      onConfirm={deleteMatch}
      loading={loading}
      error={error}
      confirmTestId="saveDeleteMatchDialogButton"
      cancelTestId="closeDeleteMatchDialogButton"
    />
  );
};

export default DeleteMatchDialog;
